// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap_ENG .main_cont .sch_form .tit[data-v-5d660e95] {\n  width: 100px !important;\n}\n.wrap_CHN .main_cont .sch_form .tit[data-v-5d660e95],\n.wrap_JPN .main_cont .sch_form .tit[data-v-5d660e95] {\n  width: 67px !important;\n}\n.ei-cat-cd-radio[data-v-5d660e95] {\n  margin: 0px 9px;\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
